import Vue from "vue";
import ELEMENT from "element-ui";
import moment from "moment";
// import VueRouter from 'vue-router'
import publicComponents from "./components";
import "@/asserts/iconfont/iconfont.css";
import "./element-variables.scss";
import "./app.scss";
import App from "./App.vue";
import routes from "./router.config";
import store from "./store";
import qs from "qs";
import { $cacheUtil } from "@/utils";
import { uploadfile } from "@/utils/request";
// import echarts from 'echarts'
import * as filters from "@/utils/filter";
import "umy-ui/lib/theme-chalk/index.css";// 引入样式
import BindingPerson from "@/components/bindingPerson/index.js";
// //引入基本模板
// let echarts = require('echarts/lib/echarts')
import "@/utils/inputMoney";
import lodash from "lodash";
import { setRouter, getCookie } from "@cttq/pc-common-api";
// 引入埋点包
import bfeSensors from "@cttq/bfe-sensors";
// 引入监控
import Monitor from "@cttq/cttq-monitor";
// // 引入折线图等组件
// require('echarts/lib/chart/line')
// require('echarts/lib/chart/bar')
// require('echarts/lib/chart/radar')
// // 引入提示框和title组件，图例
// require('echarts/lib/component/tooltip')
// require('echarts/lib/component/title')
// require('echarts/lib/component/legend')
// require('echarts/lib/component/legendScroll')//图例翻译滚动
// Vue.prototype.$echarts = echarts
// Vue.prototype.$echarts = echarts
// const R = require('ramda')
// 引入tq-ui的业务组件
import bussinessComponents from "@cttq/ui-components-pc/index.js";
window.localStorage.setItem("process.env.NODE_ENV", process.env.NODE_ENV);
Vue.use(bussinessComponents);
Vue.use(ELEMENT);
Vue.use(VueRouter);
Vue.use(qs);
// 全局注册公用组件
Vue.use(publicComponents);
Vue.use(BindingPerson);
Vue.prototype.$uploadfile = uploadfile;
Vue.prototype.$lodash = lodash;
Vue.prototype.$moment = moment;
const router = new VueRouter({
  base: process.env.VUE_APP_routerBase,
  mode: 'history',
  routes
})

setRouter(router, store);

// 全局注册过滤器 
for (const key of Object.keys(filters)) {
	Vue.filter(key, filters[key]);
}
router.beforeEach((to, from, next) => {
    // console.log(to, from, next);
  // 用户账号
  const { account } = store.state.user;
// const account = getCookie("account");
//   const { account } = to.query.account?{account:to.query.account}:store.state.user;
  if(to.query.account){
    // store.dispatch('user/settoLoginGetUsrInfo',{user:to.query.account,token:"123"}).then(data => {});
  }
  const userInfo = store.state.user.userInfo;
  const initData = store.state.init.initData;
  const versionData = store.state.init.versionData;
  const configInfo = store.state.init.configInfo;
  const crmInit = store.state.init.crmInit;
  // 1.有用户信息，正常页面跳转；2.无用户信息，先获取用户信息，再跳转页面
  if (!R.isNil(account) && !R.isEmpty(account)) {
    let loadingInstance= ELEMENT.Loading.service({ body: true });
      if (userInfo) {
          if( !userInfo.personCode ) {
            let param = { account: account };
            // store.dispatch('user/getUserInfo', param);
          }
      } else {
        let param = {
            account: account
        };
        // store.dispatch('user/getUserInfo', param);
      }
      if (to.path.indexOf('B_') == -1 && to.path.indexOf('#') == -1 && to.fullPath.indexOf('#') == -1 ) {
            let promise = new Promise(function(resolve,reject){
                if(R.isEmpty(versionData)){
                    store.dispatch('init/getVersionInit',{
                        "fillYear":moment().format('YYYY')
                    }).then(res=>{
                        resolve(res);
                    });
                }else{
                    resolve(1);
                }
                // 异步处理
                // 成功调用resolve 往下传递参数 且只接受一个参数
                // 失败调用reject  往下传递参数 且只接受一个参数
            });
            // 获取产品线主数据
            if(R.isEmpty(crmInit)){
                store.dispatch('init/getCrmInfo',{
                    "dicType":"3"
                });
            }
            loadingInstance.close();
            promise.then(function(value){
                if(R.isEmpty(configInfo)){
                        console.log(value);
                        store.dispatch('init/getConfigInfo').then(res => {
                            // loadingInstance.close();
                            if (res && res.msgCode == '100' ) {
                                topage(to,next);
                            }
                        });
                }else{
                    topage(to,next);
                }
            });
      }
  }else{
    //刷新的时候用到 vuex 重新加值
    //   let loadingInstance= ELEMENT.Loading.service({ body: true });
    //   store.dispatch('user/toLoginGetUsrInfo').then(data => {
    //         let param = {
    //             account: data.user
    //         };
    //         store.dispatch('user/getUserInfo', param);
    //         // 获取产品线主数据
    //         if(R.isEmpty(crmInit)){
    //             store.dispatch('init/getCrmInfo',{
    //                 "dicType":"3"
    //             });
    //         }
    //         // loadingInstance.close();
    //         let promise = new Promise(function(resolve,reject){
    //             if(R.isEmpty(versionData)){
    //                 store.dispatch('init/getVersionInit',{
    //                     "fillYear":moment().format('YYYY')
    //                 }).then(res=>{
    //                     resolve(res);
    //                 });
    //             }else{
    //                 resolve(1);
    //             }
    //         });
    //         promise.then(function(value){
    //             if(R.isEmpty(initData)){
    //                 store.dispatch('init/getConfigInfo').then(res => {
    //                     loadingInstance.close();
    //                     if (res && res.msgCode == '100' ) {
    //                         topage(to,next);
    //                     }
    //                 });
    //             }else{
    //                 next();
    //             }
    //         });
           
    //   });
  };
});
router.afterEach((to, from) => {
	Vue.nextTick(() => {
		console.log("跳转了++++++++++++", from);
		// sensors.quick("autoTrackSinglePage");
		// sensors.quick("autoTrackSinglePage", {
		// 	timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
		// 	$from_title: from.meta.name
		// });
		// sensors.quick("autoTrackSinglePage");
	});
});
function topage(to, next) {
	document.title = to.meta.name;
	let param = $cacheUtil.getObject("dataInitParamTemp") ? $cacheUtil.getObject("dataInitParamTemp") : $cacheUtil.getObject("dataInitParam");
	if (!R.isEmpty(param) && to.path.indexOf("/homePage") == -1 && to.path.indexOf("/managementPlatform") == -1) {
		if (!R.isNil(to.query.fillPersonId) && !R.isEmpty(to.query.fillPersonId)) {
			param.fillPersonId = to.query.fillPersonId;
			param.departCode = to.query.departCode;
		}
		if ($cacheUtil.getObject("isfromHome") && !$cacheUtil.getObject("isfromHome").fromHome) {
			if (to.query.dataVersion) {
				param.dataVersion = to.query.dataVersion;
			}
			if (to.path.indexOf("/historyReport") > -1 || to.path.indexOf("/importReport") > -1 || to.path.indexOf("/businessReport") > -1 || to.path.indexOf("/managementReport") > -1 || to.path.indexOf("/financeReport") > -1) {
				next();
			} else {
				store.dispatch("init/getDataInit", param).then(res => {
					if (res && res.msgCode == "100") {
						// debugger
						next();
					}
				});
			}
			// next();
		} else {
			$cacheUtil.setObject("isfromHome", {
				fromHome: false
			});
			next();
		}
	} else {
		next();
	}
}
Vue.filter("dateformat", function(dataStr, pattern = "YYYY-MM-DD HH:mm:ss") {
	return moment(dataStr).format(pattern);
});
Vue.config.productionTip = false;
console.log("测试");
const appVue = new Vue({
	render: h => h(App),
	// 把 store 对象提供给 “store” 选项，这可以把 store 的实例注入所有的子组件
	store,
	router
}).$mount("#app");
appVue.$store.watch(state => {
	return state.user.userInfo;
}, newValue => {
	if (newValue) {
		console.log(process.env.NODE_ENV,newValue)
		// 监控配置
		const {
			CTTQMonitor
		} = Monitor;
		CTTQMonitor().init({
			apikey: "CTTQ-Budget-WebPC",
			userInfo: appVue.$store.state.user,
			app: Vue
		});
		// 埋点配置 初始化
		const sensorsConfig = bfeSensors.SensorsConfig.init({
			project: "Budget-WebPC",
			projectName: "预算管理",
			// 运行环境
			runEnv: process.env.NODE_ENV,
			showLog: true,
			// 项目ID
			projectId: "IT2022090800002_8",
			// 人的基础信息,需要从Store中获取
			personInfo: newValue
		});
		sensorsConfig.configSensors();
		Vue.use(bfeSensors, sensorsConfig);
	}
});

